// Fonte única das Funcionalidades: alimenta o mega-menu, o hub (/funcionalidades)
// e as páginas individuais (/funcionalidades/{slug}).
// ownPage:true  → tem página própria em /funcionalidades/{slug}
// ownPage:false → é card que aponta para a página de produto existente (externalTo)

const ic = (children) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    {children}
  </svg>
);

export const featureCategories = [
  "Vendas & CRM",
  "Financeiro",
  "Atendimento, Marketing & IA",
];

export const features = [
  // ─────────────── Vendas & CRM ───────────────
  {
    slug: "gestao-de-leads",
    name: "Gestão de Leads",
    category: "Vendas & CRM",
    color: "#0560FF",
    bg: "linear-gradient(135deg, #0560FF 0%, #204493 100%)",
    ownPage: true,
    cover: "/assets/sys/gestao-leads.png",
    tagline:
      "Todos os leads de todos os canais em um funil só, com distribuição automática e histórico completo.",
    introShort:
      "Todos os leads de portais, redes, site e WhatsApp em um funil só, distribuídos automaticamente e com histórico completo.",
    intro:
      "Lead que chega e ninguém atende é venda perdida. A gestão de leads do IMOBMEET centraliza os contatos de portais, redes sociais, site e WhatsApp em um funil visual, distribui automaticamente entre os corretores e registra cada interação — para nenhuma oportunidade esfriar.",
    bullets: [
      "Captação automática de portais (ZAP, Viva Real), Facebook, Google e site, sem digitação.",
      "Distribuição de leads por regras justas: por fila, por performance ou por canal.",
      "Funil kanban por etapa, com histórico e follow-up de cada lead.",
      "Classificação (quente/frio) e SLA de atendimento para priorizar o que importa.",
      "Relatórios de origem e conversão por canal e por corretor.",
    ],
    related: [
      { label: "CRM para Incorporadoras", to: "/crm-incorporadoras" },
      { label: "CRM para Loteadoras", to: "/crm-loteadoras" },
    ],
    bulletIcons: ["inbox", "shuffle", "kanban", "flame", "chart"],
    heroShot: "/assets/sys/funil-de-leads.webp",
    heroTitle: "Funil de Venda · arraste e solte entre as etapas",
    chips: [
      { label: "Lead novo · WhatsApp", pos: "tl", icon: "whatsapp" },
      { label: "Distribuído para Marcos R.", pos: "tr", icon: "avatar", initials: "MR" },
      { label: "Origem: Meta Ads", pos: "bl", icon: "meta" },
      { label: "Movido para Reserva ✓", pos: "br", icon: "kanban" },
    ],
    logos: ["zap", "viva-real", "imovel-web", "facebook-ads", "rd-station", "hubspot", "whatsapp", "zapier", "api"],
    dores: [
      {
        antes:
          "Leads de portais, redes sociais e site chegam soltos e demoram a ser atendidos.",
        depois:
          "Captação automática e distribuição na hora — o corretor recebe o lead quente, sem digitar nada.",
      },
      {
        antes:
          "Cada corretor controla seus contatos do próprio jeito, sem histórico visível.",
        depois:
          "Funil único, com histórico e follow-up de cada lead, à vista da gestão.",
      },
      {
        antes:
          "Ninguém sabe qual canal traz venda e qual só consome verba de marketing.",
        depois:
          "Relatórios de origem e conversão por canal e por corretor para investir no que dá retorno.",
      },
    ],
    blocks: [
      {
        title: "Todos os canais em um funil só",
        text:
          "Portais (ZAP, Viva Real), Facebook e Google Ads, formulários do site e WhatsApp entram automaticamente no mesmo funil. Sem planilha e sem cadastro manual — o lead cai na etapa certa assim que chega.",
        bullets: [
          "Integração nativa com portais e mídia paga",
          "Formulários do site e WhatsApp conectados",
          "Deduplicação de leads repetidos",
        ],
        image: "/assets/funil-de-vendas-imobiliario.png",
        windowTitle: "Canais conectados ao funil",
        chips: [
          { label: "Entrou via Viva Real", pos: "tr", tone: "accent" },
          { label: "Sem duplicidade ✓", pos: "bl", tone: "success" },
        ],
      },
      {
        title: "Filas de distribuição por canal",
        text:
          "Crie uma fila para cada origem — Facebook Ads, portais, site — e defina quem recebe, em que ordem, quantos leads e em quais horários. O lead não fica parado esperando alguém “pegar”.",
        bullets: [
          "Rodízio por posição na fila, por equipe ou por corretor",
          "Limite de leads a receber e disponibilidade por horário",
          "Reatribuição automática se o corretor não responde",
        ],
        image: "/assets/sys/fila-distribuicao-leads.webp",
        windowTitle: "Filas de Distribuição · Fila Facebook Ads",
        chips: [
          { label: "Fila: Facebook Ads", pos: "tl", tone: "accent" },
          { label: "Corretor adicionado à fila ✓", pos: "br", tone: "success" },
        ],
      },
      {
        title: "Tarefas e follow-up de cada lead",
        text:
          "Ligação, e-mail, visita: cada próximo passo vira uma tarefa com início, término e responsável. O gestor enxerga o que está em andamento e o que já foi concluído — por corretor e por lead.",
        bullets: [
          "Tarefas por tipo (ligação, e-mail, visita) com prazo",
          "Status em andamento / concluído, visível para a gestão",
          "Nada de lead esquecido: o follow-up fica agendado no CRM",
        ],
        image: "/assets/sys/tarefas-do-lead.webp",
        windowTitle: "Tarefas",
        chips: [
          { label: "Ligação agendada", pos: "tr", tone: "accent" },
          { label: "Tarefa concluída ✓", pos: "bl", tone: "success" },
        ],
      },
      {
        title: "A página do lead conta a história inteira",
        text:
          "Origem, canal, responsável, unidades reservadas, proposta, contrato e o histórico de cada mudança de etapa — tudo na ficha do lead. Quem pegar o atendimento sabe exatamente onde parou.",
        bullets: [
          "Linha do tempo com cada alteração de etapa e quem fez",
          "Reserva, proposta e contrato na mesma tela",
          "Tags, valor do negócio e contato por WhatsApp em um clique",
        ],
        image: "/assets/sys/pagina-do-lead.webp",
        windowTitle: "Lead · etapas, unidade, proposta e histórico",
        chips: [
          { label: "Proposta aprovada", pos: "tl", tone: "success" },
          { label: "Etapa: Contrato", pos: "br", tone: "accent" },
        ],
      },
      {
        title: "Dashboard personalizável",
        text:
          "Monte o painel do seu jeito: leads por etapa, previsão de VGV, ranking de vendas por corretor, reservas ativas. Filtre por período, produto, origem, equipe e funil — e salve os filtros que usa sempre.",
        bullets: [
          "Widgets arrastáveis organizados em abas",
          "Filtros por produto, origem, equipe, responsável e etapa",
          "Ranking de vendas e VGV por etapa em tempo real",
        ],
        image: "/assets/sys/dashboard-personalizavel.webp",
        windowTitle: "Dashboard",
        chips: [
          { label: "Funil — leads por etapa", pos: "tr", tone: "accent" },
          { label: "Filtro salvo ✓", pos: "bl", tone: "success" },
        ],
      },
    ],
    steps: [
      { icon: "inbox", title: "Integrar canais de aquisição", text: "Conecte portais, Meta e Google Ads, site e WhatsApp: o lead entra sozinho no CRM." },
      { icon: "shuffle", title: "Crie sua fila de distribuição", text: "Defina equipe, ordem, limite de leads e horários de cada corretor por canal." },
      { icon: "bell", title: "Notificação de novo lead", text: "O corretor é avisado na hora por WhatsApp, no app e por e-mail." },
      { icon: "kanban", title: "Gestão de leads no funil", text: "Arraste o lead pelas etapas, registre tarefas e mantenha o histórico completo." },
      { icon: "chart", title: "Dashboard para análise", text: "Acompanhe leads por etapa, origem, conversão e ranking de vendas." },
    ],
    faq: [
      {
        q: "O que é gestão de leads no mercado imobiliário?",
        a: "É o processo de captar, organizar, distribuir e acompanhar os contatos interessados em comprar um imóvel ou lote, do primeiro clique até a venda. No IMOBMEET, todos os leads de portais, redes sociais, site e WhatsApp ficam em um funil único, com distribuição automática entre os corretores e histórico completo de cada atendimento.",
      },
      {
        q: "Como funciona a distribuição automática de leads?",
        a: "Você define a regra e o sistema aplica: rodízio (fila justa entre os corretores), por performance (quem converte mais recebe mais) ou por canal de origem. Se o corretor não atende dentro do prazo (SLA), o lead pode ser reatribuído automaticamente — nenhuma oportunidade fica parada.",
      },
      {
        q: "O IMOBMEET integra com portais e Facebook Ads?",
        a: "Sim. A captação é automática a partir de portais como ZAP e Viva Real, de campanhas no Facebook e Google Ads e dos formulários do próprio site, sem digitação manual. O lead entra direto no funil, na etapa certa.",
      },
      {
        q: "Consigo medir a conversão por corretor e por canal?",
        a: "Sim. Os relatórios mostram a origem dos leads, a taxa de conversão por canal e por corretor e a evolução do funil, para você direcionar a verba de marketing onde realmente gera venda.",
      },
    ],
    app: {
      title: "O funil e o lead na palma da mão",
      text: "O corretor arrasta o lead pelas etapas, vê os detalhes, liga, manda WhatsApp e e-mail — tudo do celular, no plantão ou na visita.",
      bullets: ["Funil de venda com arrastar e soltar", "Detalhes do lead com etapa, tags, valor do negócio e responsável", "Ligar, WhatsApp e e-mail em um toque"],
      shots: ["/assets/app/funil.webp", "/assets/app/lead.webp"],
    },
    seoTitle: "Gestão de Leads Imobiliário: funil de vendas | IMOBMEET",
    seoDesc:
      "Centralize leads de portais, redes e site em um funil só, com distribuição automática por corretor, follow-up e relatórios de conversão. IMOBMEET.",
    keywords:
      "gestão de leads imobiliário, funil de vendas imobiliário, distribuição de leads, crm de leads",
    icon: ic(
      <>
        <path d="M3 4h18l-7 8v6l-4 2v-8L3 4z" />
      </>
    ),
  },
  {
    slug: "gestao-de-unidades",
    name: "Gestão de Unidades e Disponibilidade",
    category: "Vendas & CRM",
    color: "#0EA5E9",
    bg: "linear-gradient(135deg, #0EA5E9 0%, #0560FF 100%)",
    ownPage: true,
    cover: "/assets/sys/gestao-unidades-vertical.png",
    tagline:
      "Disponibilidade de unidades e lotes em tempo real, com mapa humanizado — sem vender a mesma unidade duas vezes.",
    introShort:
      "Disponibilidade de unidades e lotes em tempo real, no espelho ou no mapa humanizado — sem venda em duplicidade.",
    intro:
      "Vender a mesma unidade duas vezes é o pesadelo de toda operação. A gestão de unidades do IMOBMEET mostra a disponibilidade em tempo real, em lista ou no mapa humanizado, e tira a unidade da vitrine no instante em que ela é reservada ou vendida.",
    bullets: [
      "Disponibilidade em tempo real de apartamentos e lotes.",
      "Mapa humanizado de lotes e espelho de vendas por torre ou quadra.",
      "Bloqueio automático da unidade ao reservar ou vender — zero venda em duplicidade.",
      "Tabela de preços e condições por unidade e por empreendimento.",
      "Visão de estoque e VGV por empreendimento.",
    ],
    related: [
      { label: "CRM para Incorporadoras", to: "/crm-incorporadoras" },
      { label: "Sistema para Loteamento", to: "/sistema-para-loteamento" },
    ],
    bulletIcons: ["kanban", "map", "shield", "money", "chart"],
    heroShot: "/assets/sys/espelho-vertical.webp",
    heroTitle: "Espelho de vendas · Torre 1 · status por unidade",
    // Alterna entre incorporadoras (espelho vertical) e loteadoras (mapa humanizado)
    heroShots: [
      { src: "/assets/sys/espelho-vertical.webp", title: "Incorporadoras · Espelho de vendas por torre e andar" },
      { src: "/assets/sys/mapa-humanizado-lotes.webp", title: "Loteadoras · Mapa humanizado de lotes" },
    ],
    chips: [
      { label: "Unidade 2603 vendida ✓", pos: "tl", tone: "success" },
      { label: "Reserva 2701 · prazo ativo", pos: "tr", tone: "warning" },
      { label: "Estoque atualizado em tempo real", pos: "bl", icon: "kanban" },
      { label: "Pré-reserva no 29º andar", pos: "br" },
    ],
    logos: ["sienge", "uau", "totvs", "mega", "informakon", "konstroi", "api"],
    dores: [
      { antes: "Planilha de disponibilidade desatualizada — dois corretores reservam a mesma unidade.", depois: "Espelho e mapa em tempo real: a unidade sai da vitrine no instante em que é reservada ou vendida." },
      { antes: "Gestor não enxerga estoque, VGV e status por torre ou quadra sem pedir relatório.", depois: "Visão por empreendimento com status, valores e VGV em tela — para gestores, corretores e administradores." },
      { antes: "Cliente pergunta do lote no mapa e o corretor precisa conferir por telefone.", depois: "Mapa humanizado com status por lote e link público para compartilhar a disponibilidade." },
    ],
    blocks: [
      {
        title: "Espelho de vendas vertical, andar por andar",
        text: "Cada torre e cada andar em uma grade colorida por status — vendido, disponível, reservado, pré-reserva, bloqueado. O corretor vê o que pode vender; o gestor vê o que falta vender.",
        bullets: ["Grade por torre e andar com status em cores", "Contadores e percentuais por status no topo", "Lista de unidades e configuração no mesmo lugar"],
        image: "/assets/sys/espelho-vertical.webp", windowTitle: "Gestão de Unidades · Espelho",
        chips: [{ label: "Unidade reservada", pos: "tr", tone: "warning" }, { label: "Estoque sincronizado ✓", pos: "bl", tone: "success" }],
      },
      {
        title: "Mapa humanizado de lotes",
        text: "Para loteamentos, a disponibilidade vive sobre a implantação real do empreendimento: cada lote com seu número e status, por quadra e rua. Edite o mapa, amplie, use em tela cheia no plantão.",
        bullets: ["Status por lote sobre a imagem do loteamento", "Reserva direto do mapa, com prazo de expiração", "Link de mapa público para compartilhar"],
        image: "/assets/sys/mapa-humanizado-lotes.webp", windowTitle: "Gestão de Unidades · Mapa humanizado",
        chips: [{ label: "Quadra 10 · Lote 04 reservado", pos: "tl", tone: "warning" }, { label: "Mapa público ativo", pos: "br", tone: "success" }],
      },
      {
        title: "Bloqueio automático e estoque único",
        text: "Reservou ou vendeu, a unidade bloqueia para todo mundo — no app do corretor, no site e no Autovendas. Um único estoque, zero venda em duplicidade.",
        bullets: ["Bloqueio ao reservar ou vender, em todos os canais", "Tabela de preços e condições por unidade", "Sincronização com o ERP (Sienge, UAU e outros)"],
        image: "/assets/gestao-de-unidades-imobiliarias.png", windowTitle: "Disponibilidade em todos os canais",
        chips: [{ label: "Bloqueio automático ✓", pos: "tr", tone: "success" }, { label: "Sincronizado com o ERP", pos: "bl" }],
      },
    ],
    steps: [
      { icon: "doc", title: "Cadastre o empreendimento", text: "Torres e andares ou quadras e lotes, com tabela de preços e condições." },
      { icon: "map", title: "Monte o espelho ou o mapa", text: "Grade vertical para prédios; mapa humanizado para loteamentos." },
      { icon: "users", title: "Libere para o time", text: "Corretores consultam e reservam do app; gestores acompanham." },
      { icon: "shield", title: "Reserve e bloqueie", text: "A unidade sai da vitrine na hora, em todos os canais." },
      { icon: "chart", title: "Acompanhe estoque e VGV", text: "Status, percentuais e valores por empreendimento em tempo real." },
    ],
    faq: [
      { q: "O que é espelho de vendas?", a: "É a grade que mostra todas as unidades de um empreendimento (por torre e andar) com o status de cada uma — disponível, reservada, vendida, bloqueada. No IMOBMEET o espelho é atualizado em tempo real, então corretores e gestores sempre veem a mesma disponibilidade." },
      { q: "O mapa humanizado funciona para loteamentos?", a: "Sim. O mapa humanizado usa a imagem da implantação do loteamento e marca cada lote com número e status, por quadra e rua. É possível reservar direto pelo mapa e compartilhar um link público de disponibilidade." },
      { q: "Como o IMOBMEET evita vender a mesma unidade duas vezes?", a: "Ao reservar ou vender, a unidade é bloqueada automaticamente em todos os canais — app do corretor, site e Autovendas. Existe um único estoque, então não há como dois corretores fecharem a mesma unidade." },
      { q: "A disponibilidade sincroniza com o ERP?", a: "Sim. O IMOBMEET integra com ERPs como Sienge e UAU para manter unidades, vendas e contratos sincronizados entre o comercial e o financeiro." },
    ],
    app: {
      title: "Espelho e mapa humanizado no celular",
      text: "Disponibilidade em tempo real onde a venda acontece: o corretor consulta o espelho da torre ou o mapa do loteamento e reserva na hora.",
      bullets: ["Espelho vertical dinâmico por torre e andar", "Mapa humanizado com status por lote", "Reserva direto do app"],
      shots: ["/assets/app/espelho.webp", "/assets/app/mapa.webp"],
    },
    seoTitle: "Gestão de Unidades: Disponibilidade em Tempo Real | IMOBMEET",
    seoDesc:
      "Disponibilidade de unidades e lotes em tempo real, mapa humanizado e bloqueio automático ao vender — sem venda em duplicidade. A gestão de unidades do IMOBMEET.",
    keywords:
      "gestão de unidades, disponibilidade de unidades, mapa de lotes, espelho de vendas, mapa humanizado",
    icon: ic(
      <>
        <rect x="3" y="3" width="7" height="7" rx="1" />
        <rect x="14" y="3" width="7" height="7" rx="1" />
        <rect x="3" y="14" width="7" height="7" rx="1" />
        <rect x="14" y="14" width="7" height="7" rx="1" />
      </>
    ),
  },
  {
    slug: "gestao-de-reservas",
    name: "Gestão de Reservas",
    category: "Vendas & CRM",
    color: "#6366F1",
    bg: "linear-gradient(135deg, #6366F1 0%, #4338CA 100%)",
    ownPage: true,
    cover: "/assets/sys/gestao-unidades-vertical.png",
    tagline:
      "Reservas manuais ou automáticas, com prazo, regras de aprovação e cancelamento — sob controle.",
    introShort:
      "Cada reserva com prazo, limite por corretor e aprovação por regras — o estoque sob controle.",
    intro:
      "Reserva sem regra vira unidade travada e corretor frustrado. A gestão de reservas do IMOBMEET controla cada reserva com prazo, limite por corretor e fluxo de aprovação — manual, por gestor ou automático por regras.",
    bullets: [
      "Reserva manual ou automática, com prazo de validade configurável.",
      "Aprovação manual, por gestor ou automática por regras de negócio.",
      "Limite de reservas simultâneas por corretor.",
      "Cancelamento automático ao expirar o prazo — a unidade volta ao estoque sozinha.",
      "Histórico de reservas por unidade e por corretor.",
    ],
    related: [
      { label: "CRM para Loteadoras", to: "/crm-loteadoras" },
      { label: "CRM para Incorporadoras", to: "/crm-incorporadoras" },
    ],
    bulletIcons: ["clock", "shield", "users", "bell", "doc"],
    heroShot: "/assets/sys/painel-reservas.webp",
    heroTitle: "Reservas · ativas e canceladas",
    chips: [
      { label: "Reserva ativa · Qd. 10 Lt. 04", pos: "tl", tone: "success" },
      { label: "Aprovação do gestor pendente", pos: "tr", tone: "warning" },
      { label: "Prazo expirou — lote liberado", pos: "bl", icon: "kanban" },
      { label: "Limite por corretor respeitado ✓", pos: "br", tone: "success" },
    ],
    dores: [
      { antes: "Reserva combinada no WhatsApp com o gestor: ninguém sabe até quando vale nem quem tem prioridade.", depois: "Toda reserva com data, prazo de validade, responsável e status — em um painel único." },
      { antes: "Corretor “segura” várias unidades para não perder a venda e trava o estoque de todos.", depois: "Limite de reservas simultâneas por corretor e cancelamento automático ao expirar o prazo." },
      { antes: "Aprovar reserva depende de ligar para o gestor, que não está no plantão.", depois: "Fluxo de aprovação manual, por gestor ou automático por regras — no app, de onde estiver." },
    ],
    blocks: [
      {
        title: "Painel de reservas com prazo e status",
        text: "Lead, produto, unidade, equipe, responsável, status e expiração: todas as reservas ativas e canceladas em uma lista pesquisável. O gestor sabe exatamente o que está segurando o estoque.",
        bullets: ["Ativas e canceladas com percentuais no topo", "Filtro por equipe, responsável, produto e data", "Expiração visível em cada linha"],
        image: "/assets/sys/painel-reservas.webp", windowTitle: "Reservas",
        chips: [{ label: "Ativa", pos: "tr", tone: "success" }, { label: "Cancelada ao expirar", pos: "bl" }],
      },
      {
        title: "Reserva pelo espelho ou pelo mapa",
        text: "O corretor reserva direto na unidade ou no lote, do celular, durante o atendimento. A unidade muda de status para todo mundo naquele instante.",
        bullets: ["Reserva a partir do espelho vertical ou do mapa humanizado", "Pré-reserva e reserva permanente quando a operação exige", "Histórico de reservas por unidade e por corretor"],
        image: "/assets/sys/mapa-humanizado-lotes.webp", windowTitle: "Mapa humanizado · reservar lote",
        chips: [{ label: "Reservado no mapa", pos: "tl", tone: "warning" }, { label: "Estoque atualizado ✓", pos: "br", tone: "success" }],
      },
      {
        title: "Regras que protegem o estoque",
        text: "Prazo de validade, limite por corretor e aprovação por regras: a reserva deixa de ser um favor e vira processo. Expirou, a unidade volta ao estoque sozinha.",
        bullets: ["Prazo de validade configurável por empreendimento", "Aprovação manual, por gestor ou automática", "Cancelamento automático ao expirar"],
        image: "/assets/sys/espelho-vertical.webp", windowTitle: "Espelho · status de reserva",
        chips: [{ label: "Prazo de validade ativo", pos: "tr", tone: "warning" }, { label: "Liberado para venda", pos: "bl", tone: "success" }],
      },
    ],
    steps: [
      { icon: "shield", title: "Defina as regras", text: "Prazo, limite por corretor e fluxo de aprovação por empreendimento." },
      { icon: "map", title: "Corretor reserva", text: "Pelo espelho ou pelo mapa, direto do app no atendimento." },
      { icon: "bell", title: "Gestor aprova", text: "Manual, por gestor ou automático por regras — com notificação." },
      { icon: "clock", title: "Prazo corre", text: "A reserva vale até a data; a unidade fica bloqueada para os demais." },
      { icon: "doc", title: "Vira proposta ou libera", text: "Avança para proposta e contrato, ou expira e volta ao estoque." },
    ],
    faq: [
      { q: "Como funciona a reserva de unidades no IMOBMEET?", a: "O corretor reserva a unidade ou o lote direto pelo espelho de vendas ou pelo mapa humanizado, no app. A reserva ganha data, prazo de validade, responsável e status, e a unidade fica bloqueada para os demais corretores até o prazo terminar ou a venda avançar." },
      { q: "É possível limitar quantas reservas cada corretor pode fazer?", a: "Sim. Você define o limite de reservas simultâneas por corretor, além do prazo de validade por empreendimento, para evitar que unidades fiquem travadas sem negociação real." },
      { q: "O que acontece quando a reserva expira?", a: "A reserva é cancelada automaticamente e a unidade volta ao estoque disponível, sem intervenção do gestor. O histórico da reserva fica registrado no lead e na unidade." },
      { q: "A reserva precisa de aprovação do gestor?", a: "Depende da regra que você configurar: aprovação manual, aprovação pelo gestor ou aprovação automática por regras de negócio. Em todos os casos, o fluxo acontece dentro do IMOBMEET, com notificação para quem precisa agir." },
    ],
    app: {
      title: "Reserve pelo app, durante o atendimento",
      text: "Do mapa ou do espelho, o corretor reserva a unidade no celular e a disponibilidade atualiza para toda a equipe na hora.",
      bullets: ["Reserva pelo mapa humanizado ou pelo espelho", "Status da unidade atualizado em tempo real", "Prazo e aprovação seguem as regras do empreendimento"],
      shots: ["/assets/app/mapa.webp", "/assets/app/espelho.webp"],
    },
    seoTitle: "Gestão de Reservas Imobiliárias: regras e prazos | IMOBMEET",
    seoDesc:
      "Controle reservas de unidades e lotes com prazo, limite por corretor, aprovação e cancelamento automático. A gestão de reservas do IMOBMEET.",
    keywords:
      "gestão de reservas imobiliário, reserva de unidades, reserva de lotes, aprovação de reservas",
    icon: ic(
      <>
        <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
      </>
    ),
  },
  {
    slug: "propostas-e-simulacao",
    name: "Propostas e Simulação Financeira",
    category: "Vendas & CRM",
    color: "#0D9488",
    bg: "linear-gradient(135deg, #0D9488 0%, #0F766E 100%)",
    ownPage: true,
    cover: "/assets/sys/proposta-simulacao.png",
    tagline:
      "Simulação de parcelas e proposta comercial gerada na hora, direto do celular do corretor.",
    introShort:
      "Simulação dentro da tabela do empreendimento e proposta gerada na hora, do celular do corretor.",
    intro:
      "Proposta que demora esfria a venda. Com o IMOBMEET, o corretor monta a simulação financeira e gera a proposta comercial na hora — com as condições e a tabela do empreendimento — direto do celular, no atendimento.",
    bullets: [
      "Simulador financeiro com entrada, parcelas, reforços e financiamento.",
      "Proposta comercial gerada automaticamente com a identidade da empresa.",
      "Aprovação de proposta manual, por gestor ou automática por regras.",
      "Envio da proposta ao cliente em segundos, pelo próprio app.",
      "Condições e tabelas configuráveis por empreendimento.",
    ],
    related: [
      { label: "CRM para Incorporadoras", to: "/crm-incorporadoras" },
      { label: "Autovendas", to: "/autovendas" },
    ],
    bulletIcons: ["money", "doc", "shield", "bolt", "kanban"],
    heroShot: "/assets/sys/simulador-proposta.webp",
    heroTitle: "Proposta · simulação de parcelas",
    chips: [
      { label: "Entrada + 60 meses", pos: "tl", icon: "kanban" },
      { label: "Proposta aprovada", pos: "tr", tone: "success" },
      { label: "Tabela de lançamento aplicada", pos: "bl" },
      { label: "Enviada pelo WhatsApp ✓", pos: "br", icon: "whatsapp" },
    ],
    logos: ["whatsapp", "clicksign", "docusign", "zapsign", "d4sign", "sienge", "uau"],
    dores: [
      { antes: "Corretor monta a simulação na calculadora ou na planilha e a proposta sai com condição fora da tabela.", depois: "Simulador com a tabela do empreendimento: entrada, parcelas, reforços e financiamento dentro da regra." },
      { antes: "Proposta demora horas para ser digitada, aprovada e enviada — e o cliente esfria.", depois: "Proposta gerada na hora, com a identidade da empresa, e enviada pelo app em segundos." },
      { antes: "Gestor descobre desconto fora do padrão só depois de assinado.", depois: "Aprovação manual, por gestor ou automática por regras, com painel de propostas por status." },
    ],
    blocks: [
      {
        title: "Tabela de vendas com as regras do empreendimento",
        text: "Configure por empreendimento as parcelas permitidas: entrada, mensais, semestrais, anuais — com quantidade máxima, juros (sem juros, SAC), índice de correção (IGP-M e outros), percentuais mínimo e máximo e frequência. O corretor só simula o que a tabela permite.",
        bullets: ["Tabelas por empreendimento (lançamento, pré-venda, promocional)", "Regras de juros, índice, carência e percentuais por tipo de parcela", "Alterou a tabela, todas as simulações seguem a nova regra"],
        image: "/assets/sys/tabela-de-vendas.webp", windowTitle: "Editar Tabela · Parcelas permitidas",
        chips: [{ label: "Tabela de pré-venda", pos: "tr" }, { label: "Regras aplicadas ✓", pos: "bl", tone: "success" }],
      },
      {
        title: "Simulador financeiro na tabela certa",
        text: "Escolha a tabela e o fluxo de pagamento, ajuste entrada, quantidade e valor das parcelas — o sistema calcula percentuais, vencimentos e valor da proposta na hora.",
        bullets: ["Fluxos de pagamento por empreendimento", "Entrada, mensais, reforços e financiamento", "Data-base de juros e vencimentos automáticos"],
        image: "/assets/sys/simulador-proposta.webp", windowTitle: "Proposta · simulação",
        chips: [{ label: "Valor da proposta calculado", pos: "tr", tone: "success" }, { label: "Fluxo: entrada + mensais", pos: "bl" }],
      },
      {
        title: "Painel de propostas por status",
        text: "Aprovada, aguardando, pendência, reprovada: todas as propostas com lead, unidade, responsável e data de envio. O gestor aprova ou devolve com um clique.",
        bullets: ["Percentuais por status no topo", "Aprovação manual, por gestor ou automática por regras", "Histórico da proposta no lead"],
        image: "/assets/sys/painel-propostas.webp", windowTitle: "Propostas",
        chips: [{ label: "Aguardando aprovação", pos: "tl", tone: "warning" }, { label: "Aprovada ✓", pos: "br", tone: "success" }],
      },
      {
        title: "Proposta comercial pronta, do celular",
        text: "A proposta sai em PDF com a identidade da sua empresa e vai para o cliente pelo WhatsApp direto do app do corretor — no plantão, na visita, onde a venda acontece.",
        bullets: ["PDF com a marca da incorporadora ou loteadora", "Envio pelo WhatsApp em segundos", "Segue para contrato e assinatura digital"],
        image: "/assets/proposta-comercial-mobile.png", windowTitle: "Proposta comercial · app",
        chips: [{ label: "Enviada pelo WhatsApp", pos: "tr", icon: "whatsapp" }, { label: "Cliente visualizou", pos: "bl", tone: "success" }],
      },
    ],
    steps: [
      { icon: "money", title: "Configure a tabela", text: "Parcelas permitidas, juros, índices e percentuais por empreendimento." },
      { icon: "bolt", title: "Simule na hora", text: "Entrada, parcelas, reforços e financiamento calculados automaticamente." },
      { icon: "doc", title: "Gere a proposta", text: "PDF com a identidade da empresa, direto do app." },
      { icon: "shield", title: "Aprovação", text: "Manual, por gestor ou automática por regras." },
      { icon: "kanban", title: "Avance para contrato", text: "Proposta aprovada vira contrato e assinatura digital." },
    ],
    faq: [
      { q: "Como funciona o simulador de propostas do IMOBMEET?", a: "O corretor escolhe a tabela e o fluxo de pagamento do empreendimento e ajusta entrada, quantidade e valor das parcelas. O sistema calcula percentuais, vencimentos e o valor da proposta automaticamente, sempre dentro das regras configuradas na tabela de vendas." },
      { q: "É possível ter tabelas diferentes por empreendimento?", a: "Sim. Cada empreendimento pode ter uma ou mais tabelas (lançamento, pré-venda, promocional), cada uma com suas parcelas permitidas, juros, índice de correção, carência e percentuais mínimo e máximo." },
      { q: "Quem aprova a proposta?", a: "Você define: aprovação manual, aprovação pelo gestor ou aprovação automática por regras de negócio. O painel de propostas mostra o status de cada uma — aprovada, aguardando, pendência ou reprovada." },
      { q: "A proposta vai para o cliente pelo WhatsApp?", a: "Sim. A proposta é gerada em PDF com a identidade da sua empresa e pode ser enviada ao cliente pelo WhatsApp direto do app do corretor, em segundos." },
    ],
    app: {
      title: "Simulador fácil e inteligente, no celular",
      text: "Tabela, fluxo de pagamento, entrada e parcelas calculados na hora — o corretor monta e envia a proposta sem sair da visita.",
      bullets: ["Simulação dentro da tabela do empreendimento", "Parcelas com percentual, quantidade e primeiro vencimento", "Proposta enviada ao cliente pelo WhatsApp"],
      shots: ["/assets/app/simulador.webp", "/assets/app/lead.webp"],
    },
    seoTitle: "Proposta Comercial e Simulação Financeira | IMOBMEET",
    seoDesc:
      "Gere propostas comerciais e simulações financeiras (entrada, parcelas, financiamento) na hora, do celular do corretor, com aprovação por regras. IMOBMEET.",
    keywords:
      "proposta comercial imobiliária, simulador financeiro imobiliário, simulação de parcelas, geração de propostas",
    icon: ic(
      <>
        <rect x="4" y="2" width="16" height="20" rx="2" />
        <path d="M8 6h8M8 10h8M8 14h5" />
      </>
    ),
  },
  {
    slug: "geracao-de-contratos",
    name: "Geração de Contratos",
    category: "Vendas & CRM",
    color: "#7C3AED",
    bg: "linear-gradient(135deg, #7C3AED 0%, #5B21B6 100%)",
    ownPage: true,
    cover: "/assets/sys/assinatura-online.png",
    tagline:
      "Contratos gerados automaticamente a partir de modelos configuráveis — sem copiar e colar.",
    introShort:
      "Contratos gerados dos modelos com os dados da venda, prontos para a assinatura digital e para o ERP.",
    intro:
      "Montar contrato na mão gera erro e atraso. O IMOBMEET gera o contrato automaticamente a partir de modelos configuráveis, puxando os dados da venda — pronto para assinar em minutos.",
    bullets: [
      "Modelos de contrato configuráveis por empreendimento e tipo de venda.",
      "Geração automática com os dados do cliente, unidade e condições.",
      "Fluxo direto para a assinatura digital, sem imprimir.",
      "Versionamento e histórico de cada contrato.",
      "Integração com o ERP para envio automático da venda.",
    ],
    related: [
      { label: "Assinatura Digital", to: "/funcionalidades/assinatura-digital" },
      { label: "CRM para Incorporadoras", to: "/crm-incorporadoras" },
    ],
    bulletIcons: ["doc", "bolt", "pen", "clock", "shuffle"],
    heroMockup: "sign-flow",
    chips: [
      { label: "Contrato gerado do modelo", pos: "tl", icon: "kanban" },
      { label: "Dados da venda preenchidos ✓", pos: "tr", tone: "success" },
      { label: "Signatários definidos", pos: "bl", icon: "avatar", initials: "3" },
      { label: "Enviado para assinatura", pos: "br", tone: "success" },
    ],
    logos: ["clicksign", "docusign", "zapsign", "d4sign", "sienge", "uau"],
    dores: [
      { antes: "Contrato montado no Word, copiando dados da proposta — e um erro de digitação vira aditivo.", depois: "Minuta configurável por empreendimento: o contrato nasce dos dados da venda, sem copiar e colar." },
      { antes: "Cada empreendimento tem uma minuta diferente e ninguém sabe qual é a versão atual.", depois: "Modelos versionados por empreendimento e tipo de venda, com histórico de cada contrato." },
      { antes: "Depois de pronto, imprimir, colher assinatura e escanear leva dias.", depois: "Fluxo direto para a assinatura digital (ClickSign, DocuSign, ZapSign, D4Sign) e envio automático ao ERP." },
    ],
    blocks: [
      {
        title: "Do modelo ao contrato em um clique",
        text: "Configure a minuta uma vez, com os campos da venda. Na proposta aprovada, o sistema gera o contrato preenchido — cliente, unidade, condições e parcelas — pronto para assinar.",
        bullets: ["Modelos de contrato por empreendimento e tipo de venda", "Geração automática com os dados do lead e da proposta", "Versionamento e histórico de cada contrato"],
        mockup: "sign-flow",
        chips: [{ label: "Minuta: Lançamento", pos: "tr" }, { label: "Contrato gerado ✓", pos: "bl", tone: "success" }],
      },
      {
        title: "Proposta, contrato e documentos no mesmo lead",
        text: "Na ficha do lead ficam a proposta aprovada, o contrato gerado e os documentos da negociação, com a linha do tempo de cada etapa. Nada se perde entre comercial e jurídico.",
        bullets: ["Contrato vinculado à unidade e à proposta", "Documentos da negociação com status", "Histórico de quem gerou, alterou e enviou"],
        image: "/assets/sys/pagina-do-lead.webp", windowTitle: "Lead · proposta, contrato e documentos",
        chips: [{ label: "Etapa: Contrato", pos: "tl" }, { label: "Documento anexado", pos: "br", tone: "success" }],
      },
      {
        title: "Assinatura digital e ERP no fluxo",
        text: "Gerou, escolheu os signatários e enviou: o contrato segue para a plataforma de assinatura que você já usa e, assinado, a venda vai para o ERP automaticamente.",
        bullets: ["Integração com ClickSign, DocuSign, ZapSign e D4Sign", "Corretor como signatário, quando fizer sentido", "Envio automático da venda ao Sienge, UAU e outros ERPs"],
        image: "/assets/sys/assinatura-online.png", windowTitle: "Assinatura digital integrada",
        chips: [{ label: "Enviado para assinatura", pos: "tr", tone: "success" }, { label: "Sincronizado com o ERP", pos: "bl" }],
      },
    ],
    steps: [
      { icon: "doc", title: "Configure as minutas", text: "Modelos por empreendimento e tipo de venda, com os campos da venda." },
      { icon: "shield", title: "Proposta aprovada", text: "A aprovação da proposta é o gatilho para gerar o contrato." },
      { icon: "bolt", title: "Gere o contrato", text: "Preenchido automaticamente com cliente, unidade e condições." },
      { icon: "users", title: "Defina os signatários", text: "Cliente, cônjuge, testemunhas e, se quiser, o corretor." },
      { icon: "pen", title: "Envie para assinar", text: "Assinatura digital integrada e venda enviada ao ERP." },
    ],
    faq: [
      { q: "Como o IMOBMEET gera contratos automaticamente?", a: "Você configura a minuta (modelo) do contrato com os campos da venda. Quando a proposta é aprovada, o sistema gera o contrato já preenchido com os dados do cliente, da unidade, das condições e das parcelas — sem copiar e colar." },
      { q: "Posso ter um modelo de contrato para cada empreendimento?", a: "Sim. Os modelos são configurados por empreendimento e por tipo de venda, com versionamento — assim todo mundo usa sempre a minuta atual e cada contrato guarda seu histórico." },
      { q: "Quais plataformas de assinatura digital são integradas?", a: "ClickSign, DocuSign, ZapSign e D4Sign. O contrato gerado no IMOBMEET é enviado para a plataforma da sua escolha, com os signatários definidos, sem sair do CRM." },
      { q: "O contrato vai para o ERP?", a: "Sim. Depois de assinado, a venda e o contrato são enviados automaticamente ao ERP integrado (Sienge, UAU e outros), sem redigitação pelo financeiro." },
    ],
    seoTitle: "Geração de Contratos Imobiliários Automática | IMOBMEET",
    seoDesc:
      "Gere contratos imobiliários automaticamente a partir de modelos configuráveis, com os dados da venda, prontos para assinatura digital. IMOBMEET.",
    keywords:
      "geração de contratos imobiliário, contrato de compra e venda, modelo de contrato, contrato automático",
    icon: ic(
      <>
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <path d="M14 2v6h6M9 13h6M9 17h6" />
      </>
    ),
  },
  {
    slug: "assinatura-digital",
    name: "Assinatura Digital",
    category: "Vendas & CRM",
    color: "#10B981",
    bg: "linear-gradient(135deg, #10B981 0%, #047857 100%)",
    ownPage: true,
    cover: "/assets/sys/assinatura-online.png",
    tagline:
      "Contrato assinado online em minutos, com validade jurídica — integrado a ClickSign, DocuSign, ZapSign e D4Sign.",
    introShort:
      "Contrato assinado do celular, com validade jurídica, integrado a ClickSign, DocuSign, ZapSign e D4Sign.",
    intro:
      "Assinatura em papel atrasa o fechamento. Com a assinatura digital do IMOBMEET, o contrato é assinado online, com validade jurídica, integrado a ClickSign, DocuSign, ZapSign e D4Sign — o cliente assina do celular, de onde estiver.",
    bullets: [
      "Assinatura eletrônica com validade jurídica.",
      "Integração nativa com ClickSign, DocuSign, ZapSign e D4Sign.",
      "Cliente assina pelo celular, sem imprimir nem reconhecer firma.",
      "Acompanhamento do status de cada assinatura em tempo real.",
      "Documento assinado arquivado automaticamente na pasta digital da venda.",
    ],
    related: [
      { label: "Geração de Contratos", to: "/funcionalidades/geracao-de-contratos" },
      { label: "Integrações", to: "/integracoes" },
    ],
    bulletIcons: ["shield", "shuffle", "bolt", "clock", "doc"],
    heroMockup: "sign-flow",
    chips: [
      { label: "Signatários notificados", pos: "tl", icon: "bell" },
      { label: "Cliente assinou pelo celular ✓", pos: "tr", tone: "success" },
      { label: "Validade jurídica", pos: "bl", tone: "success" },
      { label: "Arquivado na pasta digital", pos: "br" },
    ],
    logos: ["clicksign", "docusign", "zapsign", "d4sign"],
    dores: [
      { antes: "Contrato impresso, assinatura presencial, reconhecimento de firma: o fechamento atrasa dias.", depois: "Cliente assina do celular, de onde estiver, com validade jurídica." },
      { antes: "Você já usa uma plataforma de assinatura, mas o corretor precisa sair do CRM para enviar.", depois: "Envio direto do IMOBMEET para ClickSign, DocuSign, ZapSign ou D4Sign, sem trocar de sistema." },
      { antes: "Ninguém sabe quem já assinou e quem está travando o contrato.", depois: "Status de cada signatário em tempo real e documento assinado arquivado na venda." },
    ],
    blocks: [
      {
        title: "Envie para assinatura sem sair do CRM",
        text: "Adicione os signatários (e o corretor, se quiser), clique em assinar e pronto: o documento é enviado, os signatários adicionados e notificados pela plataforma que você já usa.",
        bullets: ["Integração com ClickSign, DocuSign, ZapSign e D4Sign", "Opção de adicionar o corretor como signatário", "Notificação automática dos signatários"],
        mockup: "sign-flow",
        chips: [{ label: "Enviando documento…", pos: "tr" }, { label: "Signatários notificados ✓", pos: "bl", tone: "success" }],
      },
      {
        title: "Acompanhe cada assinatura",
        text: "Quem assinou, quem falta e quando: o status de cada signatário aparece no lead. Assinado, o documento vai automaticamente para a pasta digital da venda.",
        bullets: ["Status por signatário em tempo real", "Documento assinado arquivado na venda", "Trilha de auditoria da plataforma de assinatura"],
        image: "/assets/sys/assinatura-online.png", windowTitle: "Assinatura online · status",
        chips: [{ label: "Aguardando 1 signatário", pos: "tl", tone: "warning" }, { label: "Contrato assinado ✓", pos: "br", tone: "success" }],
      },
    ],
    steps: [
      { icon: "doc", title: "Contrato gerado", text: "Do modelo, com os dados da venda." },
      { icon: "users", title: "Signatários", text: "Cliente, cônjuge, testemunhas e corretor." },
      { icon: "bolt", title: "Envio", text: "Direto para ClickSign, DocuSign, ZapSign ou D4Sign." },
      { icon: "pen", title: "Assinatura", text: "Pelo celular, com validade jurídica." },
      { icon: "shield", title: "Arquivado", text: "Documento assinado na pasta digital e venda no ERP." },
    ],
    faq: [
      { q: "A assinatura digital tem validade jurídica?", a: "Sim. As plataformas integradas (ClickSign, DocuSign, ZapSign e D4Sign) emitem assinaturas eletrônicas com validade jurídica e trilha de auditoria, conforme a legislação brasileira. Consulte sua assessoria jurídica sobre o tipo de assinatura mais adequado a cada contrato." },
      { q: "Preciso contratar a plataforma de assinatura separadamente?", a: "O IMOBMEET se integra à conta da plataforma de assinatura escolhida pela sua empresa. Você usa a que já tem (ou contrata a que preferir) e conecta ao CRM — o envio acontece sem sair do sistema." },
      { q: "O cliente precisa instalar algo para assinar?", a: "Não. O cliente recebe a notificação da plataforma de assinatura e assina pelo celular ou computador, sem imprimir nem reconhecer firma." },
      { q: "Onde fica o contrato assinado?", a: "Depois de assinado, o documento é arquivado automaticamente na pasta digital da venda, dentro do lead, e a venda segue para o ERP integrado." },
    ],
    seoTitle: "Assinatura Digital de Contratos Imobiliários | IMOBMEET",
    seoDesc:
      "Assine contratos imobiliários online, com validade jurídica, integrado a ClickSign, DocuSign, ZapSign e D4Sign — o cliente assina do celular.",
    keywords:
      "assinatura digital imobiliária, assinatura eletrônica, ClickSign, DocuSign, ZapSign, D4Sign, contrato online",
    icon: ic(
      <>
        <path d="M3 17c3-1 4-4 6-4s2 2 4 2 3-3 5-3" />
        <path d="M3 21h18" />
      </>
    ),
  },
  {
    slug: "autovendas",
    name: "Autovendas",
    category: "Vendas & CRM",
    color: "#EC4899",
    bg: "linear-gradient(135deg, #EC4899 0%, #BE185D 100%)",
    ownPage: false,
    externalTo: "/autovendas",
    cover: "/assets/proposta-comercial-mobile.png",
    tagline:
      "Venda de unidades 100% online, com pagamento via Pix, boleto ou cartão.",
    icon: ic(<path d="M13 2 3 14h7l-1 8 10-12h-7l1-8z" />),
  },

  // ─────────────── Financeiro ───────────────
  {
    slug: "gestao-de-recebiveis",
    name: "Gestão de Recebíveis",
    category: "Financeiro",
    color: "#F59E0B",
    bg: "linear-gradient(135deg, #F59E0B 0%, #B45309 100%)",
    ownPage: false,
    externalTo: "/gestao-de-recebiveis",
    cover: "/assets/gestao-de-recebiveis-imobiliarios.png",
    tagline: "Boletos, régua de cobrança no WhatsApp e fluxo de caixa previsível.",
    icon: ic(
      <>
        <path d="M4 2v20l2.5-1.5L9 22l3-1.5L15 22l2.5-1.5L20 22V2l-2.5 1.5L15 2l-3 1.5L9 2 6.5 3.5 4 2z" />
        <path d="M8 8h8M8 12h8M8 16h5" />
      </>
    ),
  },
  {
    slug: "boletos-e-integracao-bancaria",
    name: "Boletos e Integração Bancária",
    category: "Financeiro",
    color: "#D97706",
    bg: "linear-gradient(135deg, #D97706 0%, #92400E 100%)",
    ownPage: true,
    cover: "/assets/integracao-bancaria-boletos.png",
    tagline:
      "Emissão de boletos, régua de cobrança e conciliação bancária automática — o financeiro do recebível no automático.",
    introShort:
      "Boletos emitidos a cada venda, régua de cobrança por WhatsApp e e-mail e conciliação automática com o banco.",
    intro:
      "Cobrança manual gera inadimplência. O IMOBMEET emite os boletos automaticamente a cada venda, dispara a régua de cobrança por WhatsApp e e-mail e concilia os pagamentos automaticamente com o banco — o recebível no piloto automático.",
    bullets: [
      "Emissão automática de boletos a cada venda ou parcela.",
      "Segunda via de boleto na hora, inclusive com IA no WhatsApp.",
      "Régua de cobrança automática (WhatsApp e e-mail) antes e após o vencimento.",
      "Integração bancária e conciliação automática dos pagamentos.",
      "Relatórios de inadimplência por empreendimento e safra.",
    ],
    related: [
      { label: "Gestão de Recebíveis", to: "/gestao-de-recebiveis" },
      { label: "Integrações", to: "/integracoes" },
    ],
    bulletIcons: ["money", "bolt", "bell", "shuffle", "chart"],
    heroMockup: "boleto-flow",
    chips: [
      { label: "Boleto emitido automaticamente", pos: "tl", tone: "success" },
      { label: "Lembrete enviado no WhatsApp", pos: "tr", icon: "whatsapp" },
      { label: "Pagamento conciliado ✓", pos: "bl", tone: "success" },
      { label: "2ª via respondida pela IA", pos: "br", icon: "avatar", initials: "AI" },
    ],
    banks: ["itau.png", "bb.png", "santander.png", "bradesco.png", "caixa.png", "c6.png", "inter.svg", "btg.svg", "safra.png", "sicoob.png", "sicredi.png", "brb.png"],
    banksTitle: "Integrado aos principais bancos",
    banksText: "Registro, remessa e retorno automáticos.",
    banksMore: "+30 Bancos disponíveis",
    logos: ["sienge", "uau", "totvs", "mega", "whatsapp", "api", "webhook"],
    logosPosition: "bottom", // carrossel depois dos blocos, longe da faixa de bancos
    dores: [
      { antes: "Financeiro emite boleto na mão para cada parcela e a cobrança depende de alguém lembrar.", depois: "Venda ganha gera as parcelas e os boletos automaticamente; a régua de cobrança dispara sozinha." },
      { antes: "Cliente pede segunda via e espera o horário comercial.", depois: "Segunda via na hora, pelo WhatsApp, inclusive com IA — 24 horas." },
      { antes: "Baixa manual: o pagamento entra no banco e o sistema continua mostrando em aberto.", depois: "Integração bancária e conciliação automática: pagou, baixou." },
    ],
    blocks: [
      {
        title: "Boleto automático a cada venda",
        text: "Lead arrastado para venda ganha vira carteira de recebíveis: parcelas e boletos emitidos automaticamente, com desdobramento e baixas registrados.",
        bullets: ["Emissão automática por venda ou parcela", "Desdobramento de pagamentos e baixas", "Integração com os principais bancos"],
        image: "/assets/integracao-bancaria-boletos.png", windowTitle: "Contas a Receber · boletos",
        chips: [{ label: "Parcelas geradas ✓", pos: "tr", tone: "success" }, { label: "Baixa automática", pos: "bl" }],
      },
      {
        title: "Régua de cobrança no WhatsApp e e-mail",
        text: "Antes do vencimento, no dia e depois: a régua dispara lembretes com o boleto e o Pix pelo WhatsApp e por e-mail. E a IA responde pedidos de segunda via a qualquer hora.",
        bullets: ["Régua configurável antes e após o vencimento", "Segunda via com IA no WhatsApp", "Relatórios de inadimplência por empreendimento e safra"],
        mockup: "wa-chat", script: "cobranca",
        chips: [{ label: "Lembrete enviado", pos: "tl", icon: "whatsapp" }, { label: "Pagamento confirmado ✓", pos: "br", tone: "success" }],
      },
      {
        title: "Conciliação bancária automática",
        text: "O retorno do banco entra automaticamente: pagamentos conciliados, carteira atualizada e inadimplência à vista — sem planilha de baixa.",
        bullets: ["Retorno bancário automático", "Carteira de recebíveis e fluxo de caixa previsível", "Envio ao ERP (Sienge, UAU e outros)"],
        image: "/assets/gestao-de-recebiveis-imobiliarios.png", windowTitle: "Conciliação bancária",
        chips: [{ label: "Retorno bancário processado", pos: "tr", tone: "success" }, { label: "Inadimplência por safra", pos: "bl" }],
      },
    ],
    steps: [
      { icon: "kanban", title: "Venda ganha", text: "O lead vira contrato e carteira de parcelas." },
      { icon: "money", title: "Boletos emitidos", text: "Automaticamente, por parcela, no banco configurado." },
      { icon: "bell", title: "Régua de cobrança", text: "WhatsApp e e-mail antes e depois do vencimento." },
      { icon: "chat", title: "2ª via com IA", text: "O cliente pede no WhatsApp e recebe na hora." },
      { icon: "shuffle", title: "Conciliação", text: "O retorno do banco baixa os pagamentos e atualiza a carteira." },
    ],
    faq: [
      { q: "Como funciona a emissão automática de boletos?", a: "Quando o lead vira venda ganha, o IMOBMEET cria as parcelas do contrato e emite os boletos automaticamente no banco configurado, com desdobramento e baixas registrados na carteira de recebíveis." },
      { q: "Como funciona a conciliação bancária automática?", a: "O IMOBMEET troca os arquivos de remessa e retorno com os bancos automaticamente. Com isso, os pagamentos são conciliados automaticamente: o boleto pago no banco é baixado no sistema sem trabalho manual do financeiro." },
      { q: "A régua de cobrança envia pelo WhatsApp?", a: "Sim. A régua dispara lembretes por WhatsApp e e-mail antes do vencimento, no dia e depois, com o boleto e o Pix. Você configura os intervalos e as mensagens." },
      { q: "O cliente consegue a segunda via sozinho?", a: "Sim. O cliente pede a segunda via pelo WhatsApp e recebe na hora, inclusive fora do horário comercial, com atendimento por IA." },
    ],
    seoTitle: "Emissão de Boletos e Integração Bancária | IMOBMEET",
    seoDesc:
      "Emita boletos automaticamente, dispare régua de cobrança no WhatsApp e concilie pagamentos automaticamente com o banco. Reduza a inadimplência com o IMOBMEET.",
    keywords:
      "emissão de boletos imobiliário, integração bancária, conciliação bancária, régua de cobrança, segunda via de boleto",
    icon: ic(
      <>
        <rect x="2" y="5" width="20" height="14" rx="2" />
        <path d="M2 10h20M6 15h4" />
      </>
    ),
  },
  {
    slug: "split-comissoes",
    name: "Split de Comissões",
    category: "Financeiro",
    color: "#8B5CF6",
    bg: "linear-gradient(135deg, #8B5CF6 0%, #6D28D9 100%)",
    ownPage: false,
    externalTo: "/split-comissoes",
    cover: "/assets/split-de-comissoes.png",
    tagline: "Particionamento e repasse automático da comissão por venda.",
    // Página de produto /split-comissoes renderiza este conteúdo com o template rico
    introShort:
      "Comissão dividida automaticamente por venda, repasse via PIX e extrato individual — sem planilha.",
    intro:
      "Divida a comissão de cada venda entre corretores, imobiliárias e parceiros sem planilha. A pagadoria integrada do IMOBMEET calcula, repassa via PIX ou transferência e comprova cada parte — com extrato individual e conformidade fiscal.",
    bullets: [
      "Regras de split por empreendimento, equipe e papel (corretor, imobiliária, captador, gerente).",
      "Pagamento integrado: repasse via PIX ou transferência direto da plataforma.",
      "Extrato individual em tempo real para cada corretor e parceiro.",
      "Visibilidade para o gestor: o que já foi repassado e o que está a receber, por venda e por corretor.",
      "Recibos, comprovantes e retenções gerados automaticamente para a contabilidade.",
    ],
    bulletIcons: ["shuffle", "money", "doc", "bolt", "shield"],
    related: [
      { label: "Gestão de Recebíveis", to: "/gestao-de-recebiveis" },
      { label: "Boletos e Integração Bancária", to: "/funcionalidades/boletos-e-integracao-bancaria" },
    ],
    heroMockup: "split-flow",
    chips: [
      { label: "Venda fechada no CRM", pos: "tl", icon: "kanban" },
      { label: "Split aplicado automaticamente ✓", pos: "tr", tone: "success" },
      { label: "PIX enviado ao corretor", pos: "bl", icon: "avatar", initials: "PIX" },
      { label: "Recibo gerado ✓", pos: "br", tone: "success" },
    ],
    logos: ["sienge", "uau", "totvs", "mega", "api", "webhook"],
    dores: [
      { antes: "A comissão é calculada em planilha, venda por venda — e cada exceção vira uma conta refeita à mão.", depois: "Regras de split por empreendimento e papel que se aplicam sozinhas no fechamento da venda." },
      { antes: "Pagar corretor, imobiliária e captador é exportar arquivo, ir ao banco e conferir de novo.", depois: "Pagadoria integrada: repasse via PIX ou transferência direto da plataforma, com comprovante." },
      { antes: "O corretor liga toda semana para saber quanto tem a receber e quando cai.", depois: "Extrato individual em tempo real, com status de cada repasse — sem ligação, sem dúvida." },
    ],
    blocks: [
      {
        title: "Particionamento automático por venda",
        text: "Cada venda já sabe como ser dividida. As regras de split rodam sozinhas no momento do fechamento, distribuindo a comissão exatamente como combinado entre todos os envolvidos.",
        bullets: ["Regras por empreendimento, com percentuais específicos para cada lançamento", "Divisão entre corretor, imobiliária e captador em um único fluxo", "Exceções e bonificações tratadas sem refazer a conta manualmente"],
        mockup: "split-flow",
        chips: [{ label: "Regra: Lançamento Vista 21", pos: "tr" }, { label: "4 partes calculadas ✓", pos: "bl", tone: "success" }],
      },
      {
        title: "Pagadoria integrada e comprovantes",
        text: "Acabou a dúvida sobre quanto cada um tem a receber. O repasse de cada parte é executado pela pagadoria, com comprovante automático — e o financeiro fecha o período sem correria.",
        bullets: ["Repasse via PIX ou transferência sem sair do sistema", "Comprovantes e recibos gerados a cada repasse", "Retenções aplicadas e documentação pronta para a contabilidade"],
        image: "/assets/split-de-comissoes.png", windowTitle: "Comissões · pagadoria",
        chips: [{ label: "Repasse via PIX ✓", pos: "tl", tone: "success" }, { label: "Comprovante emitido", pos: "br" }],
      },
      {
        title: "Extrato individual por corretor",
        text: "Cada profissional acompanha o próprio extrato: o que foi vendido, o que está a receber, o que já caiu na conta e os comprovantes de cada repasse — direto no app, sem precisar ligar para o financeiro.",
        bullets: ["Extrato individual em tempo real", "Status de cada repasse: a receber, pago, comprovante", "Histórico por venda e por empreendimento"],
        mockup: "wa-chat", script: "comissao",
        chips: [{ label: "Extrato atualizado", pos: "tr" }, { label: "Comprovante disponível ✓", pos: "bl", tone: "success" }],
      },
    ],
    steps: [
      { icon: "shuffle", title: "Defina as regras", text: "Percentuais por empreendimento, equipe e papel de cada participante." },
      { icon: "kanban", title: "Venda fechada no CRM", text: "A comissão nasce da venda registrada — sem redigitar." },
      { icon: "bolt", title: "Split automático", text: "Cada parte calculada na hora, inclusive exceções e bonificações." },
      { icon: "money", title: "Repasse pela pagadoria", text: "PIX ou transferência, com comprovante para cada beneficiário." },
      { icon: "shield", title: "Recibos e retenções", text: "Documentação fiscal pronta e extrato atualizado para todos." },
    ],
    faq: [
      { q: "Como são definidas as regras de divisão da comissão?", a: "Você cria regras de split por empreendimento, equipe e papel de cada participante. Pode definir percentuais fixos, faixas por volume de vendas ou exceções pontuais. A regra é aplicada automaticamente assim que a venda é fechada, eliminando o cálculo manual em planilha." },
      { q: "Quais formas de pagamento estão disponíveis?", a: "O repasse de cada parte do split pode ser feito via PIX ou transferência bancária diretamente pela pagadoria integrada. Os dados de cada beneficiário ficam cadastrados na plataforma e o pagamento é executado sem precisar exportar arquivos para o banco." },
      { q: "O split se integra ao CRM e ao ERP?", a: "Sim. A comissão é gerada a partir da venda registrada no CRM e se conecta ao ERP Financeiro do IMOBMEET. Isso garante que valor de venda, recebíveis e repasses estejam sempre alinhados, sem digitação duplicada nem divergência entre sistemas." },
      { q: "E os impostos e recibos?", a: "A plataforma cuida da conformidade fiscal: aplica retenções quando necessário e emite recibos e comprovantes automaticamente para cada parte do split. A documentação fica organizada e pronta para a contabilidade fechar o período sem correria." },
    ],
    seoTitle: "Split de Comissões Imobiliário com Pagadoria Integrada | IMOBMEET",
    seoDesc:
      "Split de comissões automático: divida a comissão de cada venda entre corretores, imobiliárias e parceiros com repasse via PIX e extrato individual.",
    keywords:
      "split de comissões, pagadoria imobiliária, comissão de corretores, repasse de comissão, pagamento de corretor, CRM imobiliário",
    icon: ic(
      <>
        <circle cx="6" cy="6" r="3" />
        <circle cx="6" cy="18" r="3" />
        <circle cx="18" cy="12" r="3" />
        <path d="M9 6h3a3 3 0 0 1 3 3v0M9 18h3a3 3 0 0 0 3-3v0" />
      </>
    ),
  },

  // ─────────────── Atendimento, Marketing & IA ───────────────
  {
    slug: "hub-whatsapp",
    name: "HUB WhatsApp",
    category: "Atendimento, Marketing & IA",
    color: "#25D366",
    bg: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
    ownPage: true,
    cover: "/assets/crm-hero.jpg",
    tagline:
      "Atendimento no WhatsApp e Instagram, grupos, chatbots e fluxos de automação — tudo integrado ao CRM.",
    introShort:
      "WhatsApp e Instagram em uma caixa de entrada só, com filas, chatbots, fluxos de automação e histórico no CRM.",
    intro:
      "O cliente fala pelo WhatsApp e pelo Instagram — e a operação precisa acompanhar. O HUB do IMOBMEET centraliza o atendimento multi-corretor, cria grupos, automatiza conversas com chatbots e fluxos, e usa IA para responder, qualificar e cobrar — com o histórico no CRM.",
    bullets: [
      "Atendimento multi-corretor no WhatsApp e Instagram, com histórico no CRM.",
      "Chatbots e fluxos de automação (Chat Flow) por fila e por equipe.",
      "Criação de grupos de WhatsApp para lançamentos e equipes.",
      "Chat integrado e distribuição das conversas por corretor e etapa.",
      "Dashboard de atendimentos: TMA, TME, por fila, status e canal, com insights de IA.",
    ],
    related: [
      { label: "Inteligência Artificial", to: "/funcionalidades/inteligencia-artificial" },
      { label: "Integrações", to: "/integracoes" },
    ],
    bulletIcons: ["chat", "shuffle", "users", "kanban", "chart"],
    heroShot: "/assets/sys/hub-whatsapp-dashboard.webp",
    heroTitle: "HUB · Painel de atendimentos",
    chips: [
      { label: "Nova conversa · WhatsApp", pos: "tl", icon: "whatsapp" },
      { label: "Instagram conectado", pos: "tr" },
      { label: "Bot qualificou o lead ✓", pos: "bl", tone: "success" },
      { label: "Transferido para Comercial", pos: "br", icon: "kanban" },
    ],
    logos: ["whatsapp", "lais", "bot-conversa", "rd-station", "hubspot", "zapier", "api", "webhook"],
    dores: [
      { antes: "Cada corretor atende no próprio celular: o histórico some quando ele sai.", depois: "Atendimento centralizado, multi-corretor, com toda a conversa registrada no lead." },
      { antes: "Lead chega de madrugada e só é respondido no dia seguinte.", depois: "Chatbot e IA respondem, qualificam e agendam 24 horas — e passam para o corretor certo." },
      { antes: "Gestor não sabe tempo de espera, volume por fila nem quem está atendendo.", depois: "Dashboard com TMA, TME, demanda por fila, status e canal, com insights de IA." },
    ],
    blocks: [
      {
        title: "Uma caixa de entrada para WhatsApp e Instagram",
        text: "Conversas de WhatsApp e Instagram na mesma tela, distribuídas por fila (comercial, financeiro, suporte) e por corretor. Abertos, pendentes e fechados sempre à vista.",
        bullets: ["Multi-atendente com filas e etiquetas", "Privados e grupos no mesmo painel", "Histórico da conversa no lead do CRM"],
        mockup: "wa-chat", script: "comercial",
        chips: [{ label: "Fila: Comercial", pos: "tr" }, { label: "Atendimento assinado ✓", pos: "bl", tone: "success" }],
      },
      {
        title: "Chat Flow: fluxos de automação visuais",
        text: "Monte o fluxo arrastando nós: boas-vindas, perguntas de qualificação (loteadora, incorporadora, urbanizadora…), tabela de horários e transferência para a equipe certa — sem programar.",
        bullets: ["Editor visual de fluxos com condições e horários", "Chatbots por fila e por canal", "Transferência automática para o atendente"],
        image: "/assets/sys/hub-whatsapp-chatflow.webp", windowTitle: "Chat Flow · Comercial",
        chips: [{ label: "Fluxo: Comercial ativo", pos: "tl", tone: "success" }, { label: "Transferir → Equipe", pos: "br", icon: "kanban" }],
      },
      {
        title: "Dashboard de atendimentos com IA",
        text: "Total de atendimentos, demanda ativa e receptiva, novos contatos, TMA e TME — por fila, status e canal. E a IA analisa as métricas e sugere onde agir.",
        bullets: ["TMA e TME por período", "Distribuição por fila, status e canal", "Insights de IA sobre as métricas"],
        image: "/assets/sys/hub-whatsapp-dashboard.webp", windowTitle: "HUB · Painel de Controle",
        chips: [{ label: "Insights de IA gerados", pos: "tr", tone: "success" }, { label: "Canal: WhatsApp Official", pos: "bl", icon: "whatsapp" }],
      },
    ],
    steps: [
      { icon: "chat", title: "Conecte os canais", text: "WhatsApp (API oficial) e Instagram na mesma caixa de entrada." },
      { icon: "shuffle", title: "Crie filas e equipes", text: "Comercial, financeiro, suporte — com horários e responsáveis." },
      { icon: "bolt", title: "Monte o Chat Flow", text: "Bot de boas-vindas, qualificação e transferência automática." },
      { icon: "users", title: "Atenda em equipe", text: "Multi-corretor, com histórico no lead e grupos organizados." },
      { icon: "chart", title: "Meça e melhore", text: "Dashboard com TMA, TME e insights de IA." },
    ],
    faq: [
      { q: "O HUB funciona com o WhatsApp oficial (API)?", a: "Sim. O HUB opera com o WhatsApp Official (API oficial), além de outros conectores e do Instagram, tudo na mesma caixa de entrada." },
      { q: "Vários corretores podem atender pelo mesmo número?", a: "Sim. O atendimento é multi-corretor: as conversas são distribuídas por fila e por atendente, com etiquetas, status (aberto, pendente, fechado) e o histórico registrado no lead do CRM." },
      { q: "Dá para criar chatbots sem programar?", a: "Sim. No Chat Flow você monta o fluxo arrastando nós — boas-vindas, perguntas de qualificação, tabela de horários, transferência para a equipe — sem escrever código." },
      { q: "As conversas ficam no CRM?", a: "Sim. Cada conversa fica vinculada ao lead, com histórico completo. Quem assumir o atendimento vê tudo o que já foi conversado, no WhatsApp ou no Instagram." },
    ],
    seoTitle: "HUB WhatsApp Imobiliário: atendimento e IA | IMOBMEET",
    seoDesc:
      "Centralize o atendimento no WhatsApp multi-corretor, com histórico no CRM, IA para qualificar leads e disparos com métricas. O HUB WhatsApp do IMOBMEET.",
    keywords:
      "atendimento whatsapp imobiliário, hub whatsapp, whatsapp crm imobiliário, disparos whatsapp, ia whatsapp",
    icon: ic(
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    ),
  },
  {
    slug: "inteligencia-artificial",
    name: "Inteligência Artificial",
    category: "Atendimento, Marketing & IA",
    color: "#0284C7",
    bg: "linear-gradient(135deg, #0284C7 0%, #0560FF 100%)",
    ownPage: true,
    cover: "/assets/aerial-city.png",
    tagline:
      "Agentes de IA que atendem, qualificam e agendam no WhatsApp — treinados com a sua base de conhecimento.",
    introShort:
      "Agentes de IA que atendem, qualificam e agendam 24h no WhatsApp, com a base de conhecimento da sua empresa.",
    intro:
      "A IA do IMOBMEET trabalha junto com o time comercial: agentes configuráveis por etapas (identificar o cliente, entender a necessidade, agendar a demonstração ou a visita), com base de conhecimento própria, atendem e qualificam leads 24 horas no WhatsApp, respondem segunda via de boleto e apoiam o corretor — para ele focar no que fecha venda.",
    bullets: [
      "Agentes de IA com etapas configuráveis e base de conhecimento própria.",
      "Atendimento e qualificação de leads no WhatsApp, 24 horas por dia.",
      "Segunda via de boleto e dúvidas financeiras respondidas pela IA.",
      "Insights de IA sobre as métricas de atendimento.",
      "Playground para testar o agente antes de publicar.",
    ],
    related: [
      { label: "HUB WhatsApp", to: "/funcionalidades/hub-whatsapp" },
      { label: "Gestão de Leads", to: "/funcionalidades/gestao-de-leads" },
    ],
    bulletIcons: ["spark", "chat", "money", "chart", "bolt"],
    heroMockup: "ai-chat",
    chips: [
      { label: "Ana qualificou o lead", pos: "tl", icon: "avatar", initials: "AI" },
      { label: "Etapa 2 de 3 concluída", pos: "tr", tone: "success" },
      { label: "Respondendo no WhatsApp", pos: "bl", icon: "whatsapp" },
      { label: "Demonstração agendada ✓", pos: "br", tone: "success" },
    ],
    logos: ["whatsapp", "lais", "bot-conversa", "api", "webhook", "zapier"],
    dores: [
      { antes: "Lead chega fora do horário e só recebe resposta no dia seguinte.", depois: "Agente de IA responde na hora, 24 horas, e qualifica antes de passar ao corretor." },
      { antes: "Corretor gasta tempo com perguntas repetidas e curiosos.", depois: "A IA identifica o cliente, entende a necessidade e só agenda com quem tem perfil." },
      { antes: "Chatbot genérico que não conhece seu produto e irrita o cliente.", depois: "Base de conhecimento própria e etapas configuradas do seu jeito, testadas no playground." },
    ],
    blocks: [
      {
        title: "Uma consultora que conversa de verdade",
        text: "A Ana (ou o nome que você der) se apresenta, pergunta o que importa e conduz a conversa por etapas: identificar o cliente, entender a necessidade, agendar a demonstração ou a visita.",
        bullets: ["Etapas com campos obrigatórios e que não podem ser puladas", "Tom de voz e instruções definidos por você", "Agendamento integrado ao calendário"],
        mockup: "ai-chat",
        chips: [{ label: "Etapa: identificar cliente ✓", pos: "tr", tone: "success" }, { label: "Agendando visita…", pos: "bl" }],
      },
      {
        title: "Insights de IA no painel de atendimentos",
        text: "No painel do HUB, a IA analisa TMA, TME, demanda por fila e canal e gera insights sobre onde agir — com histórico das análises.",
        bullets: ["Análise sob demanda das métricas atuais", "Histórico de insights", "Integrado ao HUB WhatsApp"],
        image: "/assets/sys/hub-whatsapp-dashboard.webp", windowTitle: "HUB · Insights de IA",
        chips: [{ label: "Insights de IA: analisar", pos: "tr", icon: "avatar", initials: "AI" }, { label: "Análise concluída ✓", pos: "bl", tone: "success" }],
      },
      {
        title: "Segunda via e dúvidas financeiras, sem fila",
        text: "No financeiro, a IA responde pedidos de segunda via de boleto e dúvidas de vencimento no WhatsApp, a qualquer hora — e reduz o volume do atendimento humano.",
        bullets: ["2ª via de boleto automática", "Dúvidas de parcelas e vencimentos", "Escala para um atendente quando precisa"],
        mockup: "wa-chat", script: "cobranca",
        chips: [{ label: "2ª via enviada ✓", pos: "tr", tone: "success" }, { label: "Transferido ao financeiro", pos: "bl", icon: "kanban" }],
      },
    ],
    steps: [
      { icon: "doc", title: "Configure o agente", text: "Nome, instruções, tom de voz e base de conhecimento." },
      { icon: "kanban", title: "Defina as etapas", text: "Identificar cliente → necessidade → agendar demonstração." },
      { icon: "bolt", title: "Teste no playground", text: "Converse como se fosse o cliente antes de publicar." },
      { icon: "chat", title: "Publique no WhatsApp", text: "O agente atende e qualifica 24 horas." },
      { icon: "users", title: "Passe para o corretor", text: "Lead qualificado, com resumo e agendamento no CRM." },
    ],
    faq: [
      { q: "O que a IA do IMOBMEET faz?", a: "Agentes de IA atendem e qualificam leads no WhatsApp 24 horas, conduzindo a conversa por etapas configuradas por você (identificar o cliente, entender a necessidade, agendar a demonstração ou a visita). Também respondem segunda via de boleto e geram insights sobre as métricas de atendimento." },
      { q: "A IA usa informações da minha empresa?", a: "Sim. Cada agente tem uma base de conhecimento própria com os materiais da sua empresa e dos seus empreendimentos, além de instruções e tom de voz definidos por você." },
      { q: "Posso testar antes de colocar no ar?", a: "Sim. O playground permite conversar com o agente como se fosse o cliente, ajustar instruções e etapas e só então publicar no WhatsApp." },
      { q: "A IA substitui o corretor?", a: "Não. A IA faz o primeiro atendimento, qualifica e agenda; o corretor entra com o lead pronto, com resumo da conversa e o agendamento já no CRM." },
    ],
    seoTitle: "Inteligência Artificial no CRM Imobiliário | IMOBMEET",
    seoDesc:
      "IA que qualifica leads, responde no WhatsApp, automatiza tarefas e apoia o corretor a vender mais. A inteligência artificial do IMOBMEET.",
    keywords:
      "inteligência artificial imobiliário, ia crm imobiliário, ia vendas de imóveis, automação com ia",
    icon: ic(
      <>
        <path d="M12 3v2M12 19v2M5 12H3M21 12h-2M6 6l1.5 1.5M16.5 16.5 18 18M18 6l-1.5 1.5M7.5 16.5 6 18" />
        <circle cx="12" cy="12" r="4" />
      </>
    ),
  },
  {
    slug: "hotsite-do-corretor",
    name: "Hotsite do Corretor",
    isNew: true,
    category: "Atendimento, Marketing & IA",
    color: "#F97316",
    bg: "linear-gradient(135deg, #F97316 0%, #C2410C 100%)",
    ownPage: true,
    cover: "/assets/sys/hotsite-corretor.webp",
    tagline:
      "Um site pronto para cada corretor, com os empreendimentos que ele vende e páginas de produto para compartilhar com o cliente.",
    introShort:
      "Um site para cada corretor, com vitrine dos empreendimentos e páginas de produto para compartilhar — e o lead entra no funil com dono.",
    intro:
      "O corretor precisa de um lugar para mandar o cliente — e não pode depender de PDF pesado no WhatsApp. O Hotsite do Corretor do IMOBMEET gera automaticamente um site com foto, CRECI e WhatsApp do corretor, a vitrine dos empreendimentos que ele vende e uma página completa de cada produto (estrutura, localização, empreendedores) para compartilhar com um link. O lead que chega pelo hotsite entra no funil já atribuído ao corretor.",
    bullets: [
      "Site do corretor com foto, CRECI e botão Conversar no WhatsApp.",
      "Vitrine dos empreendimentos que o corretor vende, com a identidade da incorporadora ou loteadora.",
      "Página do produto com galeria por categoria (fachada, lazer, rooftop, apartamentos), localização e empreendedores.",
      "Link compartilhável por WhatsApp, Instagram e anúncios — cada corretor com o seu.",
      "Lead do hotsite cai no funil já atribuído ao corretor, com origem e canal registrados.",
    ],
    bulletIcons: ["users", "map", "doc", "chat", "kanban"],
    related: [
      { label: "Gestão de Leads", to: "/funcionalidades/gestao-de-leads" },
      { label: "Autovendas", to: "/autovendas" },
    ],
    heroShots: [
      { src: "/assets/sys/hotsite-corretor.webp", title: "Hotsite do corretor · vitrine de empreendimentos" },
      { src: "/assets/sys/hotsite-produto.webp", title: "Página do produto · galeria, localização e empreendedores" },
    ],
    heroShot: "/assets/sys/hotsite-corretor.webp",
    chips: [
      { label: "Link do corretor copiado ✓", pos: "tl", tone: "success" },
      { label: "Cliente abriu a página do produto", pos: "tr" },
      { label: "Conversar no WhatsApp", pos: "bl", icon: "whatsapp" },
      { label: "Lead atribuído ao corretor", pos: "br", icon: "avatar", initials: "CM" },
    ],
    logos: ["whatsapp", "facebook-ads", "rd-station", "zap", "viva-real", "imovel-web"],
    dores: [
      { antes: "Corretor divulga com PDF pesado e print de tabela; o cliente não acha o que precisa.", depois: "Página do produto completa — galeria, localização, empreendedores — em um link leve para compartilhar." },
      { antes: "Cada corretor monta o próprio “site” em ferramentas soltas, sem padrão nem marca.", depois: "Hotsite gerado automaticamente para cada corretor, com a identidade da incorporadora ou loteadora." },
      { antes: "Lead que vem do link do corretor entra sem origem e sem dono.", depois: "Lead do hotsite cai no funil já atribuído ao corretor, com origem e canal registrados." },
    ],
    blocks: [
      {
        title: "O site do corretor, pronto na hora",
        text: "Foto, nome, CRECI, botão Conversar no WhatsApp e a lista de empreendimentos que ele vende. Sem designer, sem hospedagem, sem manutenção — cada corretor ganha o seu assim que é cadastrado.",
        bullets: ["Identidade visual da incorporadora ou loteadora", "Botão flutuante de WhatsApp do corretor", "Empreendimentos e parceiros em destaque"],
        image: "/assets/sys/hotsite-corretor.webp", windowTitle: "Hotsite do corretor",
        chips: [{ label: "CRECI e WhatsApp do corretor", pos: "tr" }, { label: "Site publicado ✓", pos: "bl", tone: "success" }],
      },
      {
        title: "Página do produto para compartilhar com o cliente",
        text: "Cada empreendimento tem sua página: galeria por categoria (fachada, lazer, rooftop, apartamentos), localização e empreendedores. O corretor manda o link; o cliente vê tudo no celular e chama no WhatsApp.",
        bullets: ["Galeria com filtros por categoria", "Localização e empreendedores", "Conversar no WhatsApp em um toque"],
        image: "/assets/sys/hotsite-produto.webp", windowTitle: "Página do produto · Estrutura",
        chips: [{ label: "Galeria: Lazer", pos: "tl" }, { label: "Cliente chamou no WhatsApp", pos: "br", icon: "whatsapp" }],
      },
      {
        title: "Do link ao funil, com dono",
        text: "Todo contato que vem pelo hotsite entra no CRM com origem “Hotsite”, canal e o corretor responsável já definidos. Nada de lead solto nem disputa de quem atende.",
        bullets: ["Origem e canal registrados automaticamente", "Lead atribuído ao corretor do link", "Histórico e follow-up no funil"],
        image: "/assets/sys/funil-de-leads.webp", windowTitle: "Funil de Venda · origem: Hotsite",
        chips: [{ label: "Origem: Hotsite", pos: "tr" }, { label: "Atribuído ao corretor ✓", pos: "bl", tone: "success" }],
      },
    ],
    steps: [
      { icon: "users", title: "Cadastre o corretor", text: "Foto, CRECI, WhatsApp e equipe — o hotsite nasce junto." },
      { icon: "map", title: "Vincule os empreendimentos", text: "Os produtos que o corretor vende aparecem na vitrine dele." },
      { icon: "chat", title: "Compartilhe o link", text: "WhatsApp, Instagram, anúncios — um link por corretor." },
      { icon: "doc", title: "Cliente navega e conversa", text: "Página do produto completa e botão para chamar o corretor." },
      { icon: "kanban", title: "Lead no funil, com dono", text: "Entra no CRM com origem, canal e responsável definidos." },
    ],
    faq: [
      { q: "O que é o Hotsite do Corretor?", a: "É um site gerado automaticamente pelo IMOBMEET para cada corretor, com foto, CRECI, botão de WhatsApp e a vitrine dos empreendimentos que ele vende — mais uma página completa de cada produto para compartilhar com o cliente por link." },
      { q: "Preciso de designer ou hospedagem?", a: "Não. O hotsite é criado e publicado pelo próprio IMOBMEET, com a identidade visual da sua incorporadora ou loteadora. Basta cadastrar o corretor e vincular os empreendimentos." },
      { q: "O que tem na página do produto?", a: "Galeria de imagens organizada por categoria (fachada, lazer, rooftop, apartamentos), localização, empreendedores e o botão para conversar com o corretor no WhatsApp." },
      { q: "O lead que vem do hotsite vai para o CRM?", a: "Sim. O contato entra no funil com origem “Hotsite”, canal e o corretor responsável já definidos, com histórico e follow-up como qualquer outro lead." },
    ],
    seoTitle: "Hotsite do Corretor: site e página do produto | IMOBMEET",
    seoDesc:
      "Site pronto para cada corretor, com vitrine dos empreendimentos e páginas de produto para compartilhar. O lead entra no funil já atribuído ao corretor.",
    keywords:
      "hotsite do corretor, site para corretor de imóveis, página do empreendimento, landing page corretor, link do corretor",
    icon: ic(
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
      </>
    ),
  },
  {
    slug: "integracoes",
    name: "Integrações",
    category: "Atendimento, Marketing & IA",
    color: "#0D9488",
    bg: "linear-gradient(135deg, #0D9488 0%, #0F766E 100%)",
    ownPage: false,
    externalTo: "/integracoes",
    cover: "/assets/integracao-bancaria-boletos.png",
    tagline: "Sienge, UAU, portais, RD Station, ClickSign e mais.",
    icon: ic(
      <>
        <path d="M4 7h6a2 2 0 0 1 2 2v6a2 2 0 0 0 2 2h6" />
        <rect x="2" y="4" width="4" height="6" rx="1" />
        <rect x="18" y="14" width="4" height="6" rx="1" />
      </>
    ),
  },
];

export const featuresBySlug = Object.fromEntries(features.map((f) => [f.slug, f]));

// slugs com página própria (para sitemap/prerender)
export const featureOwnSlugs = features.filter((f) => f.ownPage).map((f) => f.slug);
